import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import { Form, Button, Container, Card, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';

const M11_Ejercicio8 = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [step, setStep] = useState(1);
    
    const [respuestas, setRespuestas] = useState({
        prediccion: {
            tema: '',
            temas_basicos: '',
            mensaje: ''
        },
        analisis: [
            { parrafo: 1, idea_principal: '', palabras_clave: '' },
            { parrafo: 2, idea_principal: '', palabras_clave: '' },
            { parrafo: 3, idea_principal: '', palabras_clave: '' },
            { parrafo: 4, idea_principal: '', palabras_clave: '' },
            { parrafo: 5, idea_principal: '', palabras_clave: '' }
        ],
        validacion: {
            coincide: '',
            cambios: '',
            facilito: ''
        }
    });

    const textoBase = `EL PLÁSTICO

En el medio ambientalista, el plástico es visto como un gran villano. Y no es para menos, pues en cualquier paseo ecológico nos encontramos con que artículos de ese material yacen por todas partes. El problema que esto representa es que el plástico es un material resistente que puede tardar varias décadas en descomponerse. Eso, para sorpresa de muchos, es lo mismo que lo hace un material muy ecológico.

El primer plástico apareció gracias a los jugadores de billar. Las bolas de billar, hechas antes en marfil, comenzaron a escasear debido a la caza indiscriminada de elefantes. Entonces, en 1860, en Estados Unidos, se hizo una convocatoria a un concurso para inventar un material que pudiera sustituir al marfil en la fabricación de las bolas de billar. John Hyatt fue quien se embolsilló el premio, que era de $10,000 dólares. El tipo de plástico inventado por Hyatt se llama celuloide, y al poco tiempo se comenzó a utilizar en la fabricación de distintos objetos, como mangos de cuchillo, empaques, armazones para lentes y películas cinematográficas.

A partir de 1907, se inventó la baquelita, el primer plástico calificado como termofijo, es decir que no puede ser reciclado. Al contrario de otros plásticos llamados termodinámicos, que sí pueden ser reciclados, el uso de la baquelita se extendió rápidamente a una gran cantidad de usos domésticos y componentes eléctricos.

Los buenos resultados de los plásticos provocaron que los industriales y los químicos buscaran crear otras variedades, a tal grado que en los años 30 los ingleses descubrieron que usando gas etileno se podía fabricar el polietileno. A partir de esa fecha, empezaron los problemas para el medio ambiente, que comenzó a recibir los vestigios de vasos, botellas, empaques, bolsas e incluso telas, como el nylon. Independientemente de las ventajas que los plásticos presentan, estos se convierten en basura al momento de ser usados, ya sea porque no se pueden reutilizar para el destino que había sido fabricado o porque no son reciclables. Actualmente existe una gran preocupación por la forma en que estamos usando y abusando de los plásticos. Y precisamente, esa es la clave: el plástico no es ni bueno ni malo, eso depende de lo que hagamos con él.

Los científicos han hecho grandes avances en dos campos: primero, han comenzado a desarrollar técnicas y plásticos nuevos que puedan ser reutilizados y reciclados. Segundo, han inventado un plástico biodegradable. Estos productos ya están en el mercado, y aunque no han sustituido a los plásticos nocivos en su totalidad, ya se ha dado el primer paso. El otro frente que hay que atender es el de la contaminación, y esa es tarea de todos. El no arrojar productos plásticos a la naturaleza y promover e implementar sistemas de reciclaje es responsabilidad de todos. Recuerde que el plástico no es malo; sino fuera por él, muchos productos (empaques, ropa, materiales para construcción, etc.) tendrían que producirse en madera, lo que significaría una mayor tala de bosques.`;

    const handlePrediccionChange = (campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            prediccion: { ...prev.prediccion, [campo]: valor }
        }));
    };

    const handleAnalisisChange = (index, campo, valor) => {
        const nuevoAnalisis = [...respuestas.analisis];
        nuevoAnalisis[index][campo] = valor;
        setRespuestas(prev => ({ ...prev, analisis: nuevoAnalisis }));
    };

    const handleValidacionChange = (campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            validacion: { ...prev.validacion, [campo]: valor }
        }));
    };

    const validarPasoActual = () => {
        switch (step) {
            case 1:
                // Paso 1 no requiere validación (solo es anticipación)
                return true;
            case 2:
                // Validar predicción
                return respuestas.prediccion.tema.trim() !== '' &&
                       respuestas.prediccion.temas_basicos.trim() !== '' &&
                       respuestas.prediccion.mensaje.trim() !== '';
            case 3:
                // Validar análisis de párrafos
                return respuestas.analisis.every(parrafo => 
                    parrafo.idea_principal.trim() !== '' && 
                    parrafo.palabras_clave.trim() !== ''
                );
            case 4:
                // Validar validación
                return respuestas.validacion.coincide.trim() !== '' &&
                       respuestas.validacion.cambios.trim() !== '' &&
                       respuestas.validacion.facilito.trim() !== '';
            default:
                return true;
        }
    };

    const nextStep = () => {
        if (step < 4) {
            // Validar el paso actual antes de avanzar
            if (!modoConsulta && (!validarPasoActual())) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Campos incompletos',
                    text: 'Por favor, completa todos los campos requeridos antes de continuar.',
                    confirmButtonColor: '#3085d6'
                });
                return;
            }
            setStep(step + 1);
        }
    };

    const prevStep = () => {
        if (step > 1) {
            setStep(step - 1);
        }
    };

    const validarRespuestas = () => {
        // Validar predicción
        if (!respuestas.prediccion.tema.trim() || 
            !respuestas.prediccion.temas_basicos.trim() || 
            !respuestas.prediccion.mensaje.trim()) {
            return false;
        }

        // Validar análisis de párrafos
        for (let i = 0; i < respuestas.analisis.length; i++) {
            if (!respuestas.analisis[i].idea_principal.trim() || 
                !respuestas.analisis[i].palabras_clave.trim()) {
                return false;
            }
        }

        // Validar validación
        if (!respuestas.validacion.coincide.trim() || 
            !respuestas.validacion.cambios.trim() || 
            !respuestas.validacion.facilito.trim()) {
            return false;
        }

        return true;
    };

    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        // Validar que todas las respuestas estén completas
        if (!validarRespuestas()) {
            Swal.fire({
                icon: 'warning',
                title: 'Campos incompletos',
                text: 'Por favor, completa todos los campos antes de enviar el ejercicio.',
                confirmButtonColor: '#3085d6'
            });
            return;
        }

        try {
            await addDoc(collection(db, "evaluaciones"), {
                userId: currentUser.uid,
                nombre: "Ejercicio 8 - Anticipe, prediga y confirme",
                nivel: "Avanzado",
                modulo: "11",
                createdAt: new Date(),
                tipo: "Anticipacion",
                respuestas: respuestas,
                puntaje: 0,
                puntajeMaximo: 20
            });
            
            Swal.fire({
                title: '¡Ejercicio Completado!',
                text: 'Tus respuestas han sido guardadas exitosamente.',
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Excelente'
            }).then(() => {
                if (cerrarModal) cerrarModal();
            });
        } catch (error) {
            console.error("Error al guardar resultados:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al guardar tus respuestas. Por favor, intenta nuevamente.'
            });
        }
    };

    const renderStep1 = () => (
        <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">Paso 1: Anticipación (salteo)</h5>
            </Card.Header>
            <Card.Body>
                <div className="text-muted mb-4">
                    <p>
                        <strong>Instrucciones:</strong> En esta lectura vas a practicar la anticipación mediante la técnica visual del salteo.
                        Anticiparse significa prever, antes de leer, la mayor cantidad de información posible y, con base en ella,
                        predecir los temas y argumentos que plantea el autor.
                    </p>
                    <p className="mb-2">
                        No necesitas leer todas las líneas. Realiza una sola fijación por párrafo, lee el título, observa la estructura
                        y extrae alguna palabra clave. Recorre el texto rápidamente, sin detenerte línea por línea.
                    </p>
                    <p className="mb-0">
                        <strong>Importante:</strong> completa este primer recorrido en un máximo de cinco segundos.
                    </p>
                </div>
                <div
                    className="bg-light p-3 p-md-4 rounded mb-4"
                    style={{ whiteSpace: 'pre-wrap', textAlign: 'justify', lineHeight: 1.6 }}
                >
                    {textoBase}
                </div>
                <div className="d-flex justify-content-end">
                    <Button variant="primary" onClick={nextStep}>
                        Continuar →
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );

    const renderStep2 = () => (
        <Card className="shadow-sm">
            <Card.Header className="bg-info text-white">
                <h5 className="mb-0">Paso 2: Predicción</h5>
            </Card.Header>
            <Card.Body>
                <p className="text-muted mb-4">Basándote en la anticipación, responde las siguientes preguntas:</p>
                
                <Form.Group className="mb-3">
                    <Form.Label><strong>1. ¿De qué trata la lectura?</strong></Form.Label>
                    <div className="text-muted small mb-1">Describe el tema principal que anticipas...</div>
                    <Form.Control
                        as="textarea"
                        rows={2}
                        value={respuestas.prediccion.tema}
                        onChange={(e) => handlePrediccionChange('tema', e.target.value)}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label><strong>2. ¿Cuáles son los temas básicos?</strong></Form.Label>
                    <div className="text-muted small mb-1">Menciona los temas secundarios que esperas encontrar...</div>
                    <Form.Control
                        as="textarea"
                        rows={2}
                        value={respuestas.prediccion.temas_basicos}
                        onChange={(e) => handlePrediccionChange('temas_basicos', e.target.value)}
                    />
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label><strong>3. ¿Cuál será el mensaje del autor?</strong></Form.Label>
                    <div className="text-muted small mb-1">¿Qué mensaje crees que quiere transmitir el autor?</div>
                    <Form.Control
                        as="textarea"
                        rows={2}
                        value={respuestas.prediccion.mensaje}
                        onChange={(e) => handlePrediccionChange('mensaje', e.target.value)}
                    />
                </Form.Group>

                <div className="d-flex justify-content-between">
                    <Button variant="secondary" onClick={prevStep}>
                        ← Anterior
                    </Button>
                    <Button variant="primary" onClick={nextStep}>
                        Continuar →
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );

    const renderStep3 = () => (
        <Card className="shadow-sm">
            <Card.Header className="bg-success text-white">
                <h5 className="mb-0">Paso 3: Lectura completa + análisis</h5>
            </Card.Header>
            <Card.Body>
                <p className="text-muted mb-4">Ahora lee completamente el texto y analiza cada párrafo:</p>
                
                <div
                    className="bg-light p-3 p-md-4 rounded mb-4"
                    style={{ whiteSpace: 'pre-wrap', textAlign: 'justify', lineHeight: 1.6 }}
                >
                    {textoBase}
                </div>

                {respuestas.analisis.map((parrafo, index) => (
                    <Card key={index} className="mb-3">
                        <Card.Header className="bg-light">
                            <strong>Párrafo {parrafo.parrafo}</strong>
                        </Card.Header>
                        <Card.Body>
                            <Form.Group className="mb-3">
                                <Form.Label><strong>Idea principal:</strong></Form.Label>
                                <div className="text-muted small mb-1">Describe la idea principal de este párrafo...</div>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    value={parrafo.idea_principal}
                                    onChange={(e) => handleAnalisisChange(index, 'idea_principal', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label><strong>Palabras clave:</strong></Form.Label>
                                <div className="text-muted small mb-1">Lista las palabras clave separadas por comas...</div>
                                <Form.Control
                                    type="text"
                                    value={parrafo.palabras_clave}
                                    onChange={(e) => handleAnalisisChange(index, 'palabras_clave', e.target.value)}
                                />
                            </Form.Group>
                        </Card.Body>
                    </Card>
                ))}

                <div className="d-flex justify-content-between">
                    <Button variant="secondary" onClick={prevStep}>
                        ← Anterior
                    </Button>
                    <Button variant="primary" onClick={nextStep}>
                        Continuar →
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );

    const renderStep4 = () => (
        <Card className="shadow-sm">
            <Card.Header className="bg-warning text-dark">
                <h5 className="mb-0">Paso 4: Validación</h5>
            </Card.Header>
            <Card.Body>
                <p className="text-muted mb-4">Reflexiona sobre tu proceso de comprensión:</p>
                
                <Form.Group className="mb-3">
                    <Form.Label><strong>1. ¿El argumento coincide con su predicción?</strong></Form.Label>
                    <div className="text-muted small mb-1">Compara tu predicción con lo que realmente encontraste...</div>
                    <Form.Control
                        as="textarea"
                        rows={2}
                        value={respuestas.validacion.coincide}
                        onChange={(e) => handleValidacionChange('coincide', e.target.value)}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label><strong>2. ¿Qué cambió en su interpretación?</strong></Form.Label>
                    <div className="text-muted small mb-1">Describe cómo cambió tu comprensión después de leer...</div>
                    <Form.Control
                        as="textarea"
                        rows={2}
                        value={respuestas.validacion.cambios}
                        onChange={(e) => handleValidacionChange('cambios', e.target.value)}
                    />
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label><strong>3. ¿La anticipación facilitó la comprensión?</strong></Form.Label>
                    <div className="text-muted small mb-1">¿Cómo te ayudó anticipar el contenido?</div>
                    <Form.Control
                        as="textarea"
                        rows={2}
                        value={respuestas.validacion.facilito}
                        onChange={(e) => handleValidacionChange('facilito', e.target.value)}
                    />
                </Form.Group>

                <div className="d-flex justify-content-between">
                    <Button variant="secondary" onClick={prevStep}>
                        ← Anterior
                    </Button>
                    <Button variant="success" onClick={enviarResultados}>
                        Enviar Resultados
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );

    return (
        <Container className="py-4">
            <Row className="justify-content-center">
                <Col lg={10}>
                    <div className="mb-4">
                        <h3 className="text-center mb-2">Ejercicio 8 - Anticipe, prediga y confirme</h3>
                        <p className="text-center text-muted mb-4">
                            Módulo 11 - Nivel Avanzado | Páginas 35-36
                        </p>
                        <div className="progress mb-3" style={{ height: '8px' }}>
                            <div 
                                className="progress-bar bg-primary" 
                                style={{ width: `${(step / 4) * 100}%` }}
                            ></div>
                        </div>
                        <div className="text-center">
                            <span className="badge bg-primary">Paso {step} de 4</span>
                        </div>
                    </div>

                    {step === 1 && renderStep1()}
                    {step === 2 && renderStep2()}
                    {step === 3 && renderStep3()}
                    {step === 4 && renderStep4()}
                </Col>
            </Row>
        </Container>
    );
};

export default M11_Ejercicio8;
